import React from "react"

export default function TwitterIcon(props) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M28.13 11.713v.756C28.196 20.128 22.374 29 11.804 29A16.167 16.167 0 013 26.404c.455.048.912.073 1.37.074a11.478 11.478 0 007.164-2.521 5.733 5.733 0 01-3.324-1.151 5.817 5.817 0 01-2.044-2.884c.356.075.719.113 1.083.112.51 0 1.017-.07 1.508-.205a5.73 5.73 0 01-3.324-2.007 5.823 5.823 0 01-1.304-3.681v-.084a5.572 5.572 0 002.601.729A5.754 5.754 0 014.852 12.7a5.813 5.813 0 01-.676-2.734 5.727 5.727 0 01.777-2.914 16.347 16.347 0 005.28 4.306 16.207 16.207 0 006.559 1.765 5.659 5.659 0 01-.148-1.326 5.828 5.828 0 01.991-3.26 5.748 5.748 0 012.638-2.132 5.691 5.691 0 013.37-.264 5.727 5.727 0 012.933 1.696 11.462 11.462 0 003.646-1.41 5.773 5.773 0 01-2.527 3.212A11.49 11.49 0 0031 8.706a11.434 11.434 0 01-2.87 3.007z"
        fill="currentColor"
      />
    </svg>
  )
}
